import { BackendResponse } from "../api/BackendResponse";
import { incrementValueVersion } from "./incrementValueVersion";
import { toCamelCase } from "./util";

export function withValueVersion<
  F = (args) => Promise<Partial<BackendResponse>>
>(f: F, isAsync?: true): F;
export function withValueVersion<F = (args) => Partial<BackendResponse>>(
  f: F,
  isAsync: false
): F;

export function withValueVersion(f, isAsync = true) {
  if (!isAsync) {
    return (args) => {
      const valueVersion = incrementValueVersion();

      const result = f(args);

      if (typeof result === "object") {
        result.valueVersion = valueVersion;

        return toCamelCase(result);
      }

      return result;
    };
  }

  return async (args) => {
    const valueVersion = incrementValueVersion();

    const result = await f(args);

    if (typeof result === "object") {
      result.valueVersion = valueVersion;

      return toCamelCase(result);
    }

    return result;
  };
}
